export enum UserDataTypes {
  System = 'SYSTEM',
  User = 'USER'
}

export class UserData {
  id: string;
  clientId: string;
  content: string;
  created: string;
  lastSync: string;
  deleteOnSync: boolean;
  isSynced: boolean;
  key: string;
  lastUpdate: string;
  projectId: string;
  type: UserDataTypes;
  serviceStackId: string;
  serviceStackName: string;
  editable?: boolean;
  internal?: boolean;
  sensitive?: boolean;
}

export enum UserDataKeys {
  ApiUrl = 'apiUrl',
  AccessKey = 'accessKeyId',
  Secret = 'secretAccessKey',
  QuotaGBytes = 'quotaGBytes',
  BucketName = 'bucketName',
  ConnectionString = 'connectionString',
  ConnectionStringReplicas = 'connectionStringReplicas',
  ConnectionTlsString = 'connectionTlsString',
  ConnectionTlsStringReplicas = 'connectionTlsStringReplicas',
  ConnectionStringStomp = 'connectionStringStomp',
  ConnectionStringMqtt = 'connectionStringMqtt',
  Hostname = 'hostname',
  Port = 'port',
  PortTls = 'portTls',
  PortStomp = 'portStomp',
  PortWsMqtt = 'portWsMqtt',
  PortMqtt = 'portMqtt',
  PortReplicas = 'portReplicas',
  PortTlsReplicas = 'portTlsReplicas',
  User = 'user',
  Password = 'password',
  ReadOnlyApiKey = 'readOnlyApiKey',
  ApiKey = 'apiKey',
  GrpcPort = 'grpcPort',
  GrpcConnectionString = 'grpcConnectionString',
  MasterKey = 'masterKey',
}
